import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import './i18n';
import axios from 'axios';
import { baseUrlApi } from "./config/config";
import { ConfigProvider } from 'antd';
// import en_US from 'antd/es/locale/en_US'
import pl_PL from 'antd/es/locale/pl_PL'

// Redux
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import reducers from './redux/reducers';
import sagas from './redux/sagas';
import Router from './router';
import actions from "./redux/user/actions";
import {validateLocalStorage, validateSessionStorage} from "./utils/utils";
import {ROUTE_FORGOT_PASSWORD, ROUTE_REGISTER, ROUTE_RESET_PASSWORD} from "./config/routes";

// middlewaredy
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [sagaMiddleware, routeMiddleware];
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)));
sagaMiddleware.run(sagas);

if(validateLocalStorage("access_token")){
    // @ts-ignore
    sessionStorage.setItem("access_token", localStorage.getItem("access_token"))
}

if(validateLocalStorage("superAdmin")){
    // @ts-ignore
    sessionStorage.setItem("superAdmin", localStorage.getItem("superAdmin"))
}

if(validateLocalStorage("subscriber")){
    // @ts-ignore
    sessionStorage.setItem("subscriber", localStorage.getItem("subscriber"))
}

if(validateLocalStorage("superAdminWorkspace")){
    // @ts-ignore
    sessionStorage.setItem("superAdminWorkspace", localStorage.getItem("superAdminWorkspace"))
}

// Axios
axios.defaults.baseURL = baseUrlApi;
if (validateSessionStorage("access_token")) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('access_token')}`;
} else if (validateLocalStorage("access_token")) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
}
axios.interceptors.response.use(undefined, (error) => {
    if (error.request && error.request.status === 401) {

        /** "If" operator handles unwanted redirects to login page **/
        if (window.location.pathname === ROUTE_FORGOT_PASSWORD ||
            window.location.pathname === ROUTE_RESET_PASSWORD ||
            window.location.pathname.includes(ROUTE_REGISTER().substr(0, ROUTE_REGISTER().length-4))
        ) return ;
        store.dispatch({
            type: actions.LOCAL_LOGOUT
        });
    }
    return Promise.reject(error);
});

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={pl_PL}>
            <Router history={history} />
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
export { store, history }
